<template>
  <v-card
    :color="value ? 'white' : 'grey lighten-5'"
    :elevation="value ? 12 : 0"
    class="pa-2"
    outlined
    tile
  >
    <v-card
      flat
      outlined
      tile
    >
      <v-img
        class="white--text align-end"
        height="200px"
        :src="image.medium_image_url"
      />
      <div
        :class="value && 'grey lighten-4'"
        class="pa-6 pb-12 mb-8"
      >
        <base-title
          :title="name"
          class="text-uppercase"
          space="1"
        />

        <div v-html="subtitle" />
        <!-- <base-subtitle
          :title="subtitle"
          space="8"
        /> -->

        <div class="d-flex align-center justify-center">
          <base-heading
            mobile-size="display-2"
            space="0"
            tag="h3"
          >
            {{ price }}
          </base-heading>
        </div>
      </div>
      <div v-if="orderable">
        <div
          class="px-6"
        >
          <v-text-field
            v-model="quantity"
            label="Anzahl"
            class="centered-input text--darken-3 mt-3"
            value="Select the configuration:"
            color="grey lighten-43"
            outline
            readonly
            single-line
          >
            <template v-slot:append-outer>
              <v-icon
                class="ml-6"
                x-large
                @click="increaseQty()"
              >
                mdi-plus
              </v-icon>
            </template>
            <template v-slot:prepend>
              <v-icon
                class="mr-6"
                x-large
                @click="decreaseQty()"
              >
                mdi-minus
              </v-icon>
            </template>
          </v-text-field>
        </div>

        <div class="pb-12">
          <div class="px-8 mb-12">
            <template v-for="(feature, i) in features">
              <div
                :key="feature"
                class="my-3"
                v-text="feature"
              />

              <v-divider
                v-if="i + 1 < features.length"
                :key="`divider-${i}`"
              />
            </template>
          </div>

          <base-btn
            :color="value ? 'primary' : 'accent'"
            :outlined="!value"
            width="196"
            :loading="loading"
            @click="addToCard"
          >
            In den Warenkorb
          </base-btn>
        </div>
      </div>
      <div v-else>
        Dieses Produkt ist leider nur bis  {{ orderableUntil }} Uhr bestellbar.
      </div>
    </v-card>
    <v-dialog
      v-model="dialog"
      max-width="500px"
    >
      <v-card class="pa-3">
        <v-card-title>{{ name }} zum Warenkorb hinzugefügt</v-card-title>
        <v-card-actions>
          <v-btn
            color="primary"
            @click="dialog= false"
          >
            Weiter einkaufen
          </v-btn><v-spacer />
          <v-btn
            color="primary"
            @click="(dialog= false, $store.commit('showCheckout'))"
          >
            Zum Warenkorb
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
  export default {
    name: 'MenuCard',
    provide: {
      heading: { align: 'center' },
    },
    props: {
      features: {
        type: Array,
        default: () => ([]),
      },
      price: [Number, String],
      subtitle: String,
      name: String,
      value: {
        type: Boolean,
        default: true,
      },
      id: Number,
      image: Object,
      orderableUntil: String,
    },
    data: () => ({
      quantity: 1,
      dialog: false,
      loading: false,
    }),
    computed: {
      orderable () {
        if (!this.orderableUntil) {
          return true
        }
        if ((new Date().getHours() + (new Date().getMinutes() / 60)) < parseFloat(this.orderableUntil)) {
          return true
        } else {
          return false
        }
      },
    },
    methods: {
      increaseQty () {
        this.quantity += 1
      },
      decreaseQty () {
        if (this.quantity > 1) {
          this.quantity -= 1
        }
      },
      addToCard () {
        this.loading = true
        this.$store.dispatch('addToCard', { id: this.id, quantity: this.quantity }).then(() => {
          this.loading = false
          this.quantity = 1
        })
      },
    },
  }
</script>
<style>
.centered-input input {
  text-align: center;
  font-size: 1.6em;
  line-height: 1.6em;
  padding: 0px;
}
</style>
